export enum AdminRoleId {
  SUPER_ADMIN = 1,
  ADMIN = 2,
}

export interface AdminEntity {
  id: number;
  first_name: string;
  last_name: string;
  avatar_url: string | null;
  user_id: number;
  role_id: AdminRoleId | number;
  email: string;
  permissions?: string[];
  user_status?: "PENDING" | "CONFIRMED" | "VALIDATED" | "REFUSED" | "BLOCKED";
  created_at: string;
  updated_at: string;
  is_super_admin?: boolean;
}

export interface AdminListResponseData {
  admins: AdminEntity[];
  current_page: number;
  fist_page: number;
  has_more_pages: boolean;
  has_pages: boolean;
  has_total: boolean;
  is_empty: boolean;
  last_page: number;
  per_page: number;
  total: number;
}

export interface AdminListResponse {
  error: boolean;
  data: AdminListResponseData;
}

export interface AdminShowResponse {
  error: boolean;
  data: {
    admin: AdminEntity;
  };
}

export interface CreateAdminPayload {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role_id: AdminRoleId | number;
  avatar?: File | null;
}

export interface UpdateAdminPayload {
  first_name?: string;
  last_name?: string;
  avatar?: File | null;
}


